import { render, staticRenderFns } from "./Parent.vue?vue&type=template&id=5b5855bc&scoped=true&"
import script from "./Parent.vue?vue&type=script&lang=js&"
export * from "./Parent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b5855bc",
  null
  
)

export default component.exports